export const skills = [
  {
    name: 'D3.js',
    year: 2015,
    img: (width) => (
      <svg width={width} viewBox='0 0 22.9 22.7'>
        <path
          fill='#E78E57'
          d='m.3.8h1.8c5.8,0,10.6,4.7,10.6,10.6s-4.7,10.6-10.6,10.6H.3v-4.6h1.8c3.3,0,5.9-2.7,5.9-5.9s-2.7-5.9-5.9-5.9H.3V.8Zm8.4,0h7.4c3.6,0,6.4,2.9,6.4,6.4,0,1.5-.5,3-1.5,4.1,2.3,2.7,1.9,6.8-.8,9.1-1.2,1-2.6,1.5-4.1,1.5h-7.4c1.8-1.1,3.3-2.7,4.4-4.6h3.1c1,0,1.8-.8,1.8-1.8s-.8-1.8-1.8-1.8h-1.8c.3-1.5.3-3.1,0-4.6h1.8c1,0,1.8-.8,1.8-1.8s-.8-1.8-1.8-1.8h-3.1c-1-1.9-2.5-3.5-4.4-4.6Z'
        />
      </svg>
    ),
    color: '#E78E57',
  },
  {
    name: 'React',
    year: 2016,
    img: (width) => (
      <svg width={width} viewBox='0 0 24.4 21.7'>
        <g>
          <circle cx='12.2' cy='10.9' r='2.2' fill='#61dafb' />
          <path
            d='m12.2,15.9C5.4,15.9,0,13.7,0,10.9s5.4-5,12.2-5,12.2,2.2,12.2,5-5.4,5-12.2,5Zm0-8.9c-6.6,0-11.1,2.1-11.1,3.9s4.6,3.9,11.1,3.9,11.1-2.1,11.1-3.9-4.6-3.9-11.1-3.9Z'
            fill='#61dafb'
          />
          <path
            d='m17.1,21.7c-1.1,0-2.4-.6-3.8-1.7-1.9-1.5-3.8-3.9-5.4-6.6C4.5,7.4,3.7,1.7,6.1.3c2.4-1.4,7,2.1,10.4,8.1h0c1.6,2.8,2.7,5.6,3.1,8,.4,2.6,0,4.4-1.3,5.1-.4.2-.8.3-1.2.3ZM7.3,1.1c-.3,0-.5,0-.7.2-1.6.9-1.1,5.9,2.2,11.6,1.5,2.6,3.3,4.9,5.1,6.3,1.6,1.3,3,1.8,3.8,1.3.8-.5,1.1-1.9.8-4-.4-2.3-1.4-5-2.9-7.6h0C12.7,3.9,9.2,1.1,7.3,1.1Z'
            fill='#61dafb'
          />
          <path
            d='m7.3,21.7c-.5,0-.9-.1-1.2-.3-1.2-.7-1.7-2.5-1.3-5.1.4-2.4,1.5-5.2,3.1-8C11.3,2.5,15.9-1.1,18.3.3c1.2.7,1.7,2.5,1.3,5.1-.4,2.4-1.5,5.2-3.1,8h0c-1.6,2.8-3.5,5.1-5.4,6.6-1.4,1.2-2.7,1.7-3.8,1.7ZM17.1,1.1c-1.9,0-5.4,2.9-8.3,7.9-1.5,2.6-2.6,5.3-2.9,7.6-.3,2.1,0,3.5.8,4,.8.5,2.2,0,3.8-1.3,1.8-1.4,3.6-3.7,5.1-6.3h0c1.5-2.6,2.6-5.4,2.9-7.6.3-2.1,0-3.5-.8-4-.2-.1-.4-.2-.7-.2Z'
            fill='#61dafb'
          />
        </g>
      </svg>
    ),
    color: '#61dafb',
  },
  {
    name: 'AWS',
    year: 2017,
    img: (width) => (
      <svg viewBox='0 0 24.4 19.514' width={width}>
        <g id='aws'>
          <path
            d='m6.876,7.761c0,.3.032.544.089.722.065.179.146.373.26.584.041.065.057.13.057.187,0,.081-.049.162-.154.243l-.511.341c-.073.049-.146.073-.211.073-.081,0-.162-.041-.243-.114-.114-.122-.211-.252-.292-.381-.081-.138-.162-.292-.252-.479-.633.747-1.428,1.12-2.386,1.12-.682,0-1.225-.195-1.623-.584-.398-.39-.601-.909-.601-1.558,0-.69.243-1.25.738-1.672.495-.422,1.152-.633,1.988-.633.276,0,.56.024.86.065s.609.105.933.179v-.592c0-.617-.13-1.047-.381-1.298-.26-.252-.698-.373-1.323-.373-.284,0-.576.032-.876.105s-.592.162-.876.276c-.13.057-.227.089-.284.105-.057.016-.097.024-.13.024-.114,0-.17-.081-.17-.252v-.398c0-.13.016-.227.057-.284s.114-.114.227-.17c.284-.146.625-.268,1.023-.365.398-.105.82-.154,1.266-.154.966,0,1.672.219,2.126.657.446.438.674,1.104.674,1.996v2.629h.016Zm-3.295,1.234c.268,0,.544-.049.836-.146.292-.097.552-.276.771-.519.13-.154.227-.325.276-.519s.081-.43.081-.706v-.341c-.235-.057-.487-.105-.747-.138s-.511-.049-.763-.049c-.544,0-.941.105-1.209.325-.268.219-.398.527-.398.933,0,.381.097.665.3.86.195.203.479.3.852.3Zm6.516.876c-.146,0-.243-.024-.308-.081-.065-.049-.122-.162-.17-.316l-1.907-6.273c-.049-.162-.073-.268-.073-.325,0-.13.065-.203.195-.203h.795c.154,0,.26.024.316.081.065.049.114.162.162.316l1.363,5.372,1.266-5.372c.041-.162.089-.268.154-.316.065-.049.179-.081.325-.081h.649c.154,0,.26.024.325.081.065.049.122.162.154.316l1.282,5.437,1.404-5.437c.049-.162.105-.268.162-.316.065-.049.17-.081.316-.081h.755c.13,0,.203.065.203.203,0,.041-.008.081-.016.13-.008.049-.024.114-.057.203l-1.956,6.273c-.049.162-.105.268-.17.316s-.17.081-.308.081h-.698c-.154,0-.26-.024-.325-.081s-.122-.162-.154-.325l-1.258-5.234-1.25,5.226c-.041.162-.089.268-.154.325-.065.057-.179.081-.325.081h-.698Zm10.428.219c-.422,0-.844-.049-1.25-.146-.406-.097-.722-.203-.933-.325-.13-.073-.219-.154-.252-.227-.032-.073-.049-.154-.049-.227v-.414c0-.17.065-.252.187-.252.049,0,.097.008.146.024.049.016.122.049.203.081.276.122.576.219.893.284.325.065.641.097.966.097.511,0,.909-.089,1.185-.268.276-.179.422-.438.422-.771,0-.227-.073-.414-.219-.568-.146-.154-.422-.292-.82-.422l-1.177-.365c-.592-.187-1.031-.463-1.298-.828-.268-.357-.406-.755-.406-1.177,0-.341.073-.641.219-.901.146-.26.341-.487.584-.665.243-.187.519-.325.844-.422.325-.097.665-.138,1.023-.138.179,0,.365.008.544.032.187.024.357.057.527.089.162.041.316.081.463.13.146.049.26.097.341.146.114.065.195.13.243.203.049.065.073.154.073.268v.381c0,.17-.065.26-.187.26-.065,0-.17-.032-.308-.097-.463-.211-.982-.316-1.558-.316-.463,0-.828.073-1.079.227s-.381.39-.381.722c0,.227.081.422.243.576.162.154.463.308.893.446l1.152.365c.584.187,1.006.446,1.258.779.252.333.373.714.373,1.136,0,.349-.073.665-.211.941-.146.276-.341.519-.592.714-.252.203-.552.349-.901.454-.365.114-.747.17-1.16.17Z'
            fill='#fff'
          />
          <path
            d='m22.06,14.034c-2.67,1.972-6.549,3.019-9.884,3.019-4.674,0-8.886-1.729-12.067-4.601-.252-.227-.024-.536.276-.357,3.441,1.996,7.685,3.205,12.075,3.205,2.962,0,6.216-.617,9.211-1.883.446-.203.828.292.39.617Z'
            fill='#f09d38'
          />
          <path
            d='m23.171,12.768c-.341-.438-2.256-.211-3.124-.105-.26.032-.3-.195-.065-.365,1.526-1.071,4.033-.763,4.325-.406.292.365-.081,2.873-1.509,4.074-.219.187-.43.089-.333-.154.325-.803,1.047-2.613.706-3.043Z'
            fill='#f09d38'
          />
        </g>
      </svg>
    ),
    color: '#f09d38',
  },
  {
    name: 'GCP',
    year: 2017.5,
    img: (width) => (
      <svg width={width} style={{ marginBottom: 5 }} viewBox='0 0 24.4 19.6'>
        <g>
          <path
            d='m21.4,7c-.5-1.8-1.5-3.4-2.9-4.6l-3,3c1.3,1,2,2.6,1.9,4.2v.5c1.5,0,2.6,1.2,2.6,2.6s-1.2,2.6-2.6,2.6h-5.3l-.5.5v3.2l.5.5h5.3c3.8,0,6.9-3,6.9-6.8,0-2.3-1.1-4.5-3-5.8Z'
            fill='#5382eb'
          />
          <path
            d='m6.9,19.6h5.3v-4.2h-5.3c-.4,0-.8,0-1.1-.2l-.7.2-2.1,2.1-.2.7c1.2.9,2.7,1.4,4.2,1.4Z'
            fill='#58a55c'
          />
          <path
            d='m6.9,5.8C3,5.9,0,9,0,12.8c0,2.1,1,4.1,2.7,5.4l3.1-3.1c-1.3-.6-1.9-2.2-1.3-3.5s2.2-1.9,3.5-1.3c.6.3,1.1.7,1.3,1.3l3.1-3.1c-1.3-1.7-3.3-2.7-5.5-2.7Z'
            fill='#f0be42'
          />
          <path
            d='m15.5,5.4h.7l2.1-2.1v-.9c-3.8-3.5-9.9-3.1-13.4.8-1,1.1-1.7,2.4-2.1,3.8.2,0,.5-.1.7,0l4.2-.7s.2-.4.3-.3c1.9-2.1,5.1-2.3,7.2-.6h0Z'
            fill='#d75140'
          />
        </g>
      </svg>
    ),
    color: '#5382eb',
  },
  {
    name: 'Three.js',
    year: 2018.5,
    img: (width) => (
      <svg width={width} style={{ marginLeft: '5px' }} viewBox='0 0 24.4 24.6'>
        <g id='three' fill={'white'}>
          <path d='m6.2,24.6s0,0,0,0c0,0-.2-.1-.2-.2L0,.3C0,.2,0,.1,0,0,.2,0,.3,0,.4,0l23.8,6.9c0,0,.2.1.2.2,0,0,0,.2,0,.3L6.4,24.6c0,0-.1,0-.2,0ZM.7.7l5.7,23.2L23.6,7.3.7.7Z' />
          <path d='m15.2,16s0,0,0,0l-11.9-3.4c0,0-.2-.1-.2-.2,0,0,0-.2,0-.3L12,3.5c0,0,.2,0,.3,0,0,0,.2.1.2.2l3,12c0,0,0,.2,0,.3,0,0-.1,0-.2,0Zm-11.4-3.8l11,3.2-2.7-11.1L3.8,12.2Z' />
          <path d='m9.2,14.2s0,0,0,0c0,0-.2-.1-.2-.2l-1.5-6c0,0,0-.2,0-.3,0,0,.2,0,.3,0l5.9,1.7c0,0,.2.1.2.2,0,0,0,.2,0,.3l-4.4,4.3c0,0-.1,0-.2,0Zm-1.1-5.9l1.2,5.1,3.8-3.6-5-1.4Z' />
          <path d='m7.8,8.3s0,0,0,0l-5.9-1.7c0,0-.2-.1-.2-.2,0,0,0-.2,0-.3L6.1,1.8c0,0,.2,0,.3,0,0,0,.2.1.2.2l1.5,6c0,0,0,.2,0,.3,0,0-.1,0-.2,0Zm-5.4-2.1l5,1.4-1.2-5.1-3.8,3.6Z' />
          <path d='m19.6,11.7s0,0,0,0l-5.9-1.7c0,0-.2-.1-.2-.2,0,0,0-.2,0-.3l4.4-4.3c0,0,.2,0,.3,0,0,0,.2.1.2.2l1.5,6c0,0,0,.2,0,.3,0,0-.1,0-.2,0Zm-5.4-2.1l5,1.4-1.2-5.1-3.8,3.6Z' />
          <path d='m10.7,20.2s0,0,0,0l-5.9-1.7c0,0-.2-.1-.2-.2,0,0,0-.2,0-.3l4.4-4.3c0,0,.2,0,.3,0,0,0,.2.1.2.2l1.5,6c0,0,0,.2,0,.3,0,0-.1,0-.2,0Zm-5.4-2.1l5,1.4-1.2-5.1-3.8,3.6Z' />
        </g>
      </svg>
    ),
    color: '#fff',
  },

  {
    name: 'Native',
    year: 2020,
    img: (width) => (
      <svg width={width} viewBox='0 0 24.4 26.6'>
        <g id='native'>
          <path
            d='m24.1,10.7c0-1.6-2-3.1-5.1-4,.7-3.1.4-5.6-1-6.4-.3-.2-.7-.3-1.1-.3v1.1c.2,0,.4,0,.6.1.7.4,1,1.8.7,3.7,0,.5-.1.9-.3,1.4-1-.2-2-.4-3.1-.5-.7-.9-1.3-1.7-2-2.5,1.6-1.5,3.1-2.3,4.1-2.3V0c-1.3,0-3.1,1-4.9,2.6C10.3,1,8.5,0,7.2,0v1.1c1,0,2.5.8,4.1,2.3-.7.7-1.4,1.5-2,2.4-1.1.1-2.2.3-3.1.5-.1-.5-.2-1-.3-1.4-.2-1.9,0-3.3.7-3.7.1,0,.3-.1.6-.1V0c-.4,0-.8,0-1.1.3-1.4.8-1.7,3.3-1,6.4C2.1,7.6,0,9.1,0,10.7s2,3.1,5.1,4c-.7,3.1-.4,5.6,1,6.4.3.2.7.3,1.1.3,1.3,0,3.1-1,4.9-2.6,1.8,1.7,3.6,2.6,4.9,2.6s.8,0,1.1-.3c1.4-.8,1.7-3.3,1-6.4,3-.9,5-2.4,5-4h0Zm-6.4-3.3c-.2.6-.4,1.3-.7,1.9-.2-.4-.4-.8-.6-1.2-.2-.4-.5-.8-.7-1.1.7.1,1.4.2,2,.4h0Zm-2.2,5.2c-.4.7-.8,1.3-1.2,1.9-.7,0-1.5,0-2.2,0s-1.5,0-2.2,0c-.4-.6-.8-1.2-1.2-1.9-.4-.6-.7-1.3-1-2,.3-.7.6-1.3,1-2,.4-.7.8-1.3,1.2-1.9.7,0,1.5,0,2.2,0s1.5,0,2.2,0c.4.6.8,1.2,1.2,1.9.4.6.7,1.3,1,2-.3.7-.6,1.3-1,2Zm1.6-.6c.3.6.5,1.3.7,2-.6.2-1.3.3-2,.4.2-.4.5-.8.7-1.2.2-.4.4-.8.6-1.2h0Zm-5,5.2c-.5-.5-.9-1-1.4-1.6.4,0,.9,0,1.3,0s.9,0,1.4,0c-.4.5-.9,1.1-1.3,1.6Zm-3.7-2.9c-.7-.1-1.4-.2-2-.4.2-.6.4-1.3.7-1.9.2.4.4.8.6,1.2.2.4.5.8.7,1.1Zm3.6-10.2c.5.5.9,1,1.4,1.6-.4,0-.9,0-1.3,0s-.9,0-1.4,0c.4-.5.9-1.1,1.3-1.6Zm-3.6,2.9c-.2.4-.5.8-.7,1.2-.2.4-.4.8-.6,1.2-.3-.6-.5-1.3-.7-2,.6-.2,1.3-.3,2-.4Zm-4.4,6.1c-1.7-.7-2.9-1.7-2.9-2.5s1.1-1.7,2.9-2.5c.4-.2.9-.3,1.4-.5.3,1,.6,2,1.1,3-.5,1-.8,2-1.1,3-.5-.2-.9-.3-1.4-.5h0Zm2.6,7c-.7-.4-1-1.8-.7-3.7,0-.5.1-.9.3-1.4,1,.2,2,.4,3.1.5.7.9,1.3,1.7,2,2.5-1.6,1.5-3.1,2.3-4.1,2.3-.2,0-.4,0-.6-.1Zm11.6-3.7c.2,1.9,0,3.3-.7,3.7-.1,0-.3.1-.6.1-1,0-2.5-.8-4.1-2.3.7-.7,1.4-1.5,2-2.4,1.1-.1,2.2-.3,3.1-.5.1.5.2,1,.3,1.4h0Zm1.9-3.3c-.4.2-.9.3-1.4.5-.3-1-.6-2-1.1-3,.5-1,.8-2,1.1-3,.5.2.9.3,1.4.5,1.7.7,2.9,1.7,2.9,2.5,0,.8-1.1,1.7-2.9,2.5h0Z'
            fill='#61dafb'
          />
          <path
            d='m12.1,13c1.2,0,2.2-1,2.2-2.2s-1-2.2-2.2-2.2-2.2,1-2.2,2.2,1,2.2,2.2,2.2ZM1.2,25.3H.4v1.3h-.4v-3.2h1c.4,0,.6,0,.8.2.2.2.3.4.3.7s0,.4-.2.5c-.1.1-.3.3-.4.3l.7,1.3h0s-.4,0-.4,0l-.7-1.3Zm-.7-.3h.6c.2,0,.4,0,.5-.2.1-.1.2-.2.2-.4s0-.3-.2-.4c-.1-.1-.3-.2-.5-.2H.4v1.2Zm3.2,1.7c-.3,0-.6-.1-.8-.3-.2-.2-.3-.5-.3-.8h0c0-.3,0-.5.1-.7,0-.2.2-.3.4-.4.2-.1.3-.2.5-.2.3,0,.5.1.7.3.2.2.3.5.3.9v.2h-1.6c0,.2,0,.4.2.6.1.1.3.2.5.2s.3,0,.4,0c0,0,.2-.1.3-.2l.2.2c-.2.3-.5.5-.9.5h0Zm0-2.1c-.2,0-.3,0-.4.2-.1.1-.2.3-.2.5h1.2c0-.2,0-.4-.2-.5,0-.1-.2-.2-.4-.2h0Zm2.9,2.1s0-.1,0-.2c-.2.2-.4.3-.7.3s-.4,0-.6-.2c-.1-.1-.2-.3-.2-.5s0-.4.3-.6c.2-.1.4-.2.8-.2h.4v-.2c0-.1,0-.3-.1-.3,0,0-.2-.1-.4-.1s-.3,0-.4.1c0,0-.1.2-.1.3h-.4c0-.1,0-.2.1-.3,0-.1.2-.2.3-.3.1,0,.3,0,.5,0,.3,0,.5,0,.6.2.2.1.2.3.2.6v1.1c0,.2,0,.4,0,.5h0s-.4,0-.4,0Zm-.7-.3c.1,0,.2,0,.4,0,.1,0,.2-.1.2-.3v-.5h-.3c-.5,0-.7.1-.7.4s0,.2.1.3c0,0,.2.1.3.1h0Zm2.6,0c.1,0,.3,0,.4-.1s.2-.2.2-.3h.4c0,.1,0,.3-.1.4s-.2.2-.3.3c-.1,0-.3.1-.5.1-.3,0-.6-.1-.8-.3-.2-.2-.3-.5-.3-.9h0c0-.3,0-.5.1-.7,0-.2.2-.3.4-.4.2,0,.3-.1.6-.1s.5,0,.7.2c.2.2.3.4.3.6h-.4c0-.2,0-.3-.2-.4-.1,0-.2-.1-.4-.1s-.4,0-.5.2c-.1.1-.2.4-.2.6h0c0,.3,0,.6.2.7.1.1.3.2.5.2h0Zm1.9-2.6v.6h.4v.3h-.4v1.5c0,0,0,.2,0,.2,0,0,.1,0,.2,0s.1,0,.2,0v.3c-.1,0-.2,0-.3,0-.2,0-.3,0-.4-.2,0-.1-.1-.3-.1-.5v-1.5h-.4v-.3h.4v-.6h.4Zm4.5,2.9h-.4l-1.6-2.4v2.4h-.4v-3.2h.4l1.6,2.4v-2.4h.4v3.2Zm2.1,0s0-.1,0-.2c-.2.2-.4.3-.7.3s-.4,0-.6-.2c-.1-.1-.2-.3-.2-.5s0-.4.3-.6c.2-.1.4-.2.8-.2h.4v-.2c0-.1,0-.3-.1-.3,0,0-.2-.1-.4-.1s-.3,0-.4.1c0,0-.1.2-.1.3h-.4c0-.1,0-.2.1-.3,0-.1.2-.2.3-.3.1,0,.3,0,.5,0,.3,0,.5,0,.6.2.2.1.2.3.2.6v1.1c0,.2,0,.4,0,.5h0s-.4,0-.4,0Zm-.7-.3c.1,0,.2,0,.4,0,.1,0,.2-.1.2-.3v-.5h-.3c-.5,0-.7.1-.7.4s0,.2.1.3c0,0,.2.1.3.1h0Zm2.2-2.6v.6h.4v.3h-.4v1.5c0,0,0,.2,0,.2,0,0,.1,0,.2,0s.1,0,.2,0v.3c-.1,0-.2,0-.3,0-.2,0-.3,0-.4-.2,0-.1-.1-.3-.1-.5v-1.5h-.4v-.3h.4v-.6h.4Zm1.3,2.9h-.4v-2.3h.4v2.3Zm-.4-3c0,0,0-.1,0-.2,0,0,0,0,.2,0s.1,0,.2,0,0,0,0,.2,0,.1,0,.2c0,0,0,0-.2,0s-.1,0-.2,0c0,0,0,0,0-.2Zm1.8,2.4l.6-1.8h.4l-.8,2.3h-.3l-.8-2.3h.4l.6,1.8Zm2.3.6c-.3,0-.6-.1-.8-.3-.2-.2-.3-.5-.3-.8h0c0-.3,0-.5.1-.7,0-.2.2-.3.4-.4.2-.1.3-.2.5-.2.3,0,.5.1.7.3.2.2.3.5.3.9v.2h-1.6c0,.2,0,.4.2.6.1.1.3.2.5.2s.3,0,.4,0,.2-.1.3-.2l.2.2c-.2.3-.5.5-.9.5h0Zm0-2.1c-.2,0-.3,0-.4.2-.1.1-.2.3-.2.5h1.2c0-.2,0-.4-.2-.5,0-.1-.2-.2-.4-.2h0Z'
            fill='#61dafb'
          />
        </g>
      </svg>
    ),
    color: '#61dafb',
  },
  {
    name: 'MUI',
    year: 2020,
    img: (width) => (
      <svg width={width} viewBox='0 0 24.4 21'>
        <defs>
          <clipPath id='clippath'>
            <path
              d='m1.1,80.8h1.8c5.8,0,10.6,4.7,10.6,10.6s-4.7,10.6-10.6,10.6h-1.8v-4.6h1.8c3.3,0,5.9-2.7,5.9-5.9s-2.7-5.9-5.9-5.9h-1.8v-4.6Zm8.4,0h7.4c3.6,0,6.4,2.9,6.4,6.4,0,1.5-.5,3-1.5,4.1,2.3,2.7,1.9,6.8-.8,9.1-1.2,1-2.6,1.5-4.1,1.5h-7.4c1.8-1.1,3.3-2.7,4.4-4.6h3.1c1,0,1.8-.8,1.8-1.8s-.8-1.8-1.8-1.8h-1.8c.3-1.5.3-3.1,0-4.6h1.8c1,0,1.8-.8,1.8-1.8s-.8-1.8-1.8-1.8h-3.1c-1-1.9-2.5-3.5-4.4-4.6Z'
              fill='none'
            />
          </clipPath>
          <linearGradient
            id='linear-gradient'
            x1='-298.3'
            y1='223.8'
            x2='-292.4'
            y2='217.9'
            gradientTransform='translate(1029.7 852.1) scale(3.4 -3.4)'
            gradientUnits='userSpaceOnUse'
          >
            <stop offset='0' stop-color='#e1755f' />
            <stop offset='1' stop-color='#eba351' />
          </linearGradient>
        </defs>
        <g id='mui'>
          <path
            d='m17.4,6.2c0,1.8,0,3.6,0,5.4,0,.4-.1.6-.5.8-1.2.7-2.4,1.4-3.6,2.1-.6.3-.6,1,0,1.3.7.4,1.3.7,2,1.1.3.2.6.2.8,0,1.5-.8,2.9-1.7,4.4-2.5.3-.2.4-.4.4-.7,0-1.2,0-2.5,0-3.7,0-.4.1-.6.5-.8.6-.3,1.3-.7,1.9-1.1.5-.3,1.1,0,1.1.6,0,2.3,0,4.7,0,7,0,.3-.1.5-.4.7-2.6,1.5-5.3,3-7.9,4.5-.3.2-.5.2-.8,0-2.1-1.2-4.1-2.4-6.2-3.5-.3-.1-.4-.4-.4-.7,0-1.1,0-2.2,0-3.3,0-.2,0-.3.2-.3,1.6-.9,3.2-1.8,4.8-2.8.2,0,.2-.2.2-.4,0-1.1,0-2.1,0-3.2,0-.6-.6-1-1.2-.7-1.2.7-2.4,1.4-3.6,2.1-.3.2-.6.2-.9,0-1.2-.7-2.4-1.4-3.6-2.1-.6-.4-1.2,0-1.2.7,0,2,0,4,0,6,0,0,0,.1,0,.2,0,.5-.5.8-1,.6-.7-.4-1.5-.8-2.2-1.2C0,12.2,0,11.9,0,11.7c0-1.3,0-2.5,0-3.8,0-2.4,0-4.7,0-7.1C0,0,.6-.2,1.1.1c2.4,1.4,4.8,2.7,7.1,4.1.3.2.6.2.9,0,2.4-1.4,4.8-2.7,7.1-4.1.1,0,.3-.1.5-.2.4,0,.7.2.7.6,0,.5,0,.9,0,1.4,0,1.4,0,2.8,0,4.2Z'
            fill='#367df7'
          />
          <path
            d='m21,3.1c0-.4,0-.8,0-1.2,0-.3.1-.5.3-.6.7-.4,1.3-.8,2-1.2.5-.3,1,0,1,.6,0,.8,0,1.6,0,2.3,0,.3-.1.5-.4.7-.6.4-1.3.8-1.9,1.1-.5.3-1.1,0-1.1-.6,0-.4,0-.8,0-1.2Z'
            fill='#367df7'
          />
        </g>
        <g id='d3'>
          <g style={{ clipPath: 'url(#clippath)' }}>
            <path
              d='m-22.1,57.1L47.6,126.8'
              fill='none; stroke:url(#linear-gradient); stroke-miterlimit:13.8; stroke-width:137.9px'
            />
          </g>
        </g>
      </svg>
    ),
    color: '#367df7',
  },
  {
    name: 'Framer',
    year: 2020.5,
    img: (width) => (
      <svg width={width} viewBox='0 0 22.3 22.3'>
        <defs>
          <clipPath id='clippath'>
            <path
              d='m.1,41.5h1.8c5.8,0,10.6,4.7,10.6,10.6s-4.7,10.6-10.6,10.6H.1v-4.6h1.8c3.3,0,5.9-2.7,5.9-5.9s-2.7-5.9-5.9-5.9H.1v-4.6Zm8.4,0h7.4c3.6,0,6.4,2.9,6.4,6.4,0,1.5-.5,3-1.5,4.1,2.3,2.7,1.9,6.8-.8,9.1-1.2,1-2.6,1.5-4.1,1.5h-7.4c1.8-1.1,3.3-2.7,4.4-4.6h3.1c1,0,1.8-.8,1.8-1.8s-.8-1.8-1.8-1.8h-1.8c.3-1.5.3-3.1,0-4.6h1.8c1,0,1.8-.8,1.8-1.8s-.8-1.8-1.8-1.8h-3.1c-1-1.9-2.5-3.5-4.4-4.6Z'
              fill='none'
            />
          </clipPath>
          <linearGradient
            id='linear-gradient'
            x1='-302.9'
            y1='176'
            x2='-300'
            y2='173.1'
            gradientTransform='translate(1032.3 677) scale(3.4 -3.4)'
            gradientUnits='userSpaceOnUse'
          >
            <stop offset='0' stop-color='#eba351' />
            <stop offset='1' stop-color='#e99a5c' />
          </linearGradient>
          <linearGradient
            id='linear-gradient-2'
            x1='-292.1'
            y1='189.2'
            x2='-287.8'
            y2='184.9'
            gradientTransform='translate(1032.3 677) scale(3.4 -3.4)'
            gradientUnits='userSpaceOnUse'
          >
            <stop offset='0' stop-color='#aa5454' />
            <stop offset='1' stop-color='#e79257' />
          </linearGradient>
          <linearGradient
            id='linear-gradient-3'
            x1='-299.3'
            y1='184.5'
            x2='-293.5'
            y2='178.5'
            gradientTransform='translate(1032.3 677) scale(3.4 -3.4)'
            gradientUnits='userSpaceOnUse'
          >
            <stop offset='0' stop-color='#e1755f' />
            <stop offset='1' stop-color='#eba351' />
          </linearGradient>
        </defs>
        <g id='d3'>
          <g style={{ clipPath: 'url(#clippath)' }}>
            <path
              d='m-29.6,17.8v69.7H40.1L-29.6,17.8Z'
              fill='url(#linear-gradient)'
            />
            <path
              d='m-16.6,17.8H53.1v69.7L-16.6,17.8Z'
              fill='url(#linear-gradient-2)'
            />
            <path
              d='m-23.1,17.8L46.6,87.5'
              fill='none; stroke:url(#linear-gradient-3); stroke-miterlimit:13.8; stroke-width:137.9px'
            />
          </g>
        </g>
        <g id='motion'>
          <path
            d='m22.3,0v11.2l-5.6,5.6-5.6,5.6-5.6-5.6,5.6-5.6h0c0,0,0,0,0,0L22.3,0Z'
            fill='#585297'
          />
          <path d='m22.3,11.2v11.2l-5.6-5.6,5.6-5.6Z' fill='#5870ae' />
          <path
            d='m11.2,11.2l-5.6,5.6L0,22.3V0l5.6,5.6,5.6,5.6Z'
            fill='#ad5292'
          />
        </g>
      </svg>
    ),
    color: '#ad5292',
  },

  {
    name: 'Svelte',
    year: 2021,
    img: (width) => (
      <svg width={width} viewBox='0 0 20.9 25.2'>
        <g id='svelte'>
          <path
            d='m19.6,3.3C17.3,0,12.6-1,9.3,1.1l-5.9,3.8C1.8,5.9.7,7.5.4,9.4c-.3,1.6,0,3.2.7,4.5-.5.8-.9,1.6-1,2.5-.3,1.9.1,3.9,1.2,5.4,2.3,3.3,6.9,4.3,10.3,2.2l5.9-3.7c1.6-1,2.7-2.6,3-4.5.3-1.6,0-3.2-.7-4.5.5-.8.9-1.6,1-2.5.4-1.9,0-3.9-1.2-5.4'
            fill='#ea5027'
          />
          <path
            d='m8.7,22.2c-1.9.5-3.9-.3-5-1.9-.7-.9-.9-2.1-.7-3.3,0-.2,0-.4.1-.6v-.3c.1,0,.4.2.4.2.7.5,1.5.9,2.3,1.2h.2c0,0,0,.3,0,.3,0,.3,0,.6.2.9.3.5.9.7,1.5.6.1,0,.3,0,.4-.1l5.8-3.7c.3-.2.5-.5.6-.8,0-.3,0-.7-.2-1-.3-.5-.9-.7-1.5-.6-.1,0-.3,0-.4.1l-2.2,1.4c-.4.2-.8.4-1.2.5-1.9.5-3.9-.3-5-1.9-.7-.9-.9-2.1-.7-3.3.2-1.1.9-2.1,1.8-2.7l5.9-3.7c.4-.2.8-.4,1.2-.5,1.9-.5,3.9.3,5,1.9.7.9.9,2.1.7,3.3,0,.2,0,.4-.1.6v.3c-.1,0-.4-.2-.4-.2-.7-.5-1.5-.9-2.3-1.2h-.2c0,0,0-.3,0-.3,0-.3,0-.6-.2-.9-.3-.5-.9-.7-1.5-.6-.1,0-.3,0-.4.1l-5.8,3.7c-.3.2-.5.5-.6.8s0,.7.2,1c.3.5.9.7,1.5.6.1,0,.3,0,.4-.1l2.2-1.4c.4-.2.8-.4,1.2-.5,1.9-.5,3.9.3,5,1.9.7.9.9,2.1.7,3.3-.2,1.1-.9,2.1-1.8,2.7l-5.9,3.7c-.4.2-.8.4-1.2.5'
            fill='#fff'
          />
        </g>
      </svg>
    ),
    color: '#ea5027',
  },
]
